// extracted by mini-css-extract-plugin
module.exports = {"logo":"navigationBar_logo__1ao5W"};